<template>
  <div class="flex h-screen bg-gray-100">
    <aside class="nav-container w-64 bg-blue-900 text-white flex flex-col p-4 space-y-8">
      <!-- Barre de navigation identique -->
      <div class="flex items-center">
        <img src="/image/im8.png" alt="Logo AdminGate" class="h-16 w-16 mr-2">
        <h1 class="text-1xl font-bold font-serif">AdminGate</h1>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im34.png" class="h-6 w-6 mr-2">
        <router-link to="/dash" class="hover:bg-blue-900 p-2 rounded transition">Dashboard</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im36.png" class="h-6 w-6 mr-2">
        <router-link to="/student" class="hover:bg-blue-900 p-2 rounded transition">Étudiants</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/icour.png" class="h-6 w-6 mr-2">
        <router-link to="/study" class="hover:bg-blue-900 p-2 rounded transition">Cours</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im35.png" class="h-6 w-6 mr-2">
        <router-link to="/event" class="hover:bg-blue-900 p-2 rounded transition">Calendrier</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im33.png" class="h-6 w-6 mr-2">
        <router-link to="/note" class="hover:bg-blue-900 p-2 rounded transition">Évaluations</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im38.png" class="h-6 w-6 mr-2">
        <router-link to="/" class="hover:bg-blue-900 p-2 rounded transition">Logout</router-link>
      </div>
    </aside>

    <main class="flex-1 p-6 overflow-y-auto bg-white">
      <div class="max-w-4xl mx-auto space-y-8 font-serif">
        <div>
          <div class="flex justify-center font-serif">
            <img src="/image/im44.png" class="h-8 w-8 mr-2" />
            <h2 class="text-3xl text-blue-900 mb-4">Gestion des Évaluations</h2>
          </div>

          <h2 class="text-1xl font-bold mb-4">Ajouter/Modifier une évaluation</h2>
          <form @submit.prevent="isEditing ? modifierEvaluation() : ajouterEvaluation()" class="grid grid-cols-2 gap-4 p-6 rounded shadow">

            <input v-model="form.matricule" placeholder="Matricule" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />


            <input v-model="form.cours" placeholder="Cours" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            
            <input v-model="form.prof" placeholder="Professeur" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />

            <input v-model="form.semestre" placeholder="Semestre" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            
            <input v-model="form.note" type="number" min="0" max="20" step="0.1" placeholder="Note" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />

            <select v-model="form.statut" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none">
              <option value="">Statut</option>
              <option value="validé">Validé</option>
              <option value="non validé">Non validé</option>
            </select>

            <input v-model="form.credit" type="number" min="1" placeholder="Crédits" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />

            <div class="col-span-2 flex justify-center">
              <button type="submit" class="w-[100px] h-8 bg-blue-900 text-white rounded hover:bg-blue-800 transition duration-300">
                {{ isEditing ? "Modifier" : "Ajouter" }}
              </button>
              <button v-if="isEditing" type="button" @click="annulerModification" class="ml-4 w-[100px] h-8 bg-gray-500 text-white rounded hover:bg-gray-600 transition duration-300">
                Annuler
              </button>
            </div>
          </form>
        </div>

        <div>
          <h2 class="text-1xl font-bold mb-4">Liste des évaluations</h2>

          <table class="min-w-full bg-white rounded shadow font-serif">
            <thead>
              <tr class="bg-blue-900 text-white text-left">
                <th class="py-2 px-4">Matricule</th>
                <th class="py-2 px-4">Cours</th>
                <th class="py-2 px-4">Professeur</th>
                <th class="py-2 px-4">Semestre</th>
                <th class="py-2 px-4">Note</th>
                <th class="py-2 px-4">Statut</th>
                <th class="py-2 px-4">Crédits</th>
                <th class="py-2 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="evals in evaluationList" :key="evals.id" class="border-b">
                 <td class="py-2 px-4">{{ evals.matricule }}</td>
                <td class="py-2 px-4">{{ evals.cours }}</td>
                <td class="py-2 px-4">{{ evals.prof }}</td>
                <td class="py-2 px-4">{{ evals.semestre }}</td>
                <td class="py-2 px-4">{{ evals.note }}</td>
                <td class="py-2 px-4">{{ evals.statut }}</td>
                <td class="py-2 px-4">{{ evals.credit }}</td>
                <td class="py-4 px-4 flex space-x-4">
                  <button @click="editerEvaluation(evals)">
                    <img src="/image/im40.png" alt="Modifier" class="w-5 h-5 hover:scale-110 transition" />
                  </button>
                  <button @click="supprimerEvaluation(evals.id)">
                    <img src="/image/im41.png" alt="Supprimer" class="w-5 h-5 hover:scale-110 transition" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'EvaluationView',
  data() {
    return {
      form: {
        id: null,
        cours: '',
        prof: '',
        semestre: '',
        note: '',
        statut: '',
        credit: ''
      },
      evaluationList: [],
      isEditing: false,
    }
  },
  mounted() {
    this.getEvaluations()
  },
  methods: {
    getEvaluations() {
      axios.get('https://mida-back.onrender.com/api/evaluations')
        .then(response => {
          this.evaluationList = response.data
          console.log('Évaluations récupérées:', this.evaluationList)
        })
        .catch(err => {
          console.error('Erreur récupération évaluations', err)
          console.error('Réponse complète:', err.response)
        })
    },

    ajouterEvaluation() {
      if (!this.form.cours || !this.form.prof || !this.form.semestre || 
          !this.form.note || !this.form.statut || !this.form.credit) {
        alert("Veuillez remplir tous les champs obligatoires.")
        return
      }

      axios.post('https://mida-back.onrender.com/api/evaluations', this.form)
        .then(() => {
          alert('Évaluation ajoutée avec succès !')
          this.reinitialiserForm()
          this.getEvaluations()
        })
        .catch(error => {
          alert('Erreur lors de l\'ajout de l\'évaluation')
          console.error(error.response.data)
        })
    },

    editerEvaluation(evals) {
      this.isEditing = true
      this.form = { ...evals }
    },

    modifierEvaluation() {
      if (!this.form.cours || !this.form.prof || !this.form.semestre || 
          !this.form.note || !this.form.statut || !this.form.credit) {
        alert("Veuillez remplir tous les champs obligatoires.")
        return
      }

      if (!confirm("Voulez-vous vraiment modifier cette évaluation ?")) return

      axios.put(`https://mida-back.onrender.com/api/evaluations/${this.form.id}`, this.form)
        .then(() => {
          alert('Évaluation modifiée avec succès !')
          this.reinitialiserForm()
          this.getEvaluations()
          this.isEditing = false
        })
        .catch(error => {
          alert('Erreur lors de la modification de l\'évaluation')
          console.error(error.response.data)
        })
    },

    supprimerEvaluation(id) {
      if (!confirm("Voulez-vous vraiment supprimer cette évaluation ?")) return

      axios.delete(`https://mida-back.onrender.com/api/evaluations/${id}`)
        .then(() => {
          alert('Évaluation supprimée avec succès !')
          this.evaluationList = this.evaluationList.filter(e => e.id !== id)
        })
        .catch(error => {
          alert('Erreur lors de la suppression de l\'évaluation')
          console.error(error.response.data)
        })
    },

    annulerModification() {
      this.isEditing = false
      this.reinitialiserForm()
    },

    reinitialiserForm() {
      this.form = {
        id: null,
        cours: '',
        prof: '',
        semestre: '',
        note: '',
        statut: '',
        credit: ''
      }
    }
  }
}
</script>

<style scoped>

.nav-container {
  background-color: #163767;
  position: sticky;
  top: 0;
  height: 100vh;
}

input, select {
  display: block;
  margin: 5px 0;
  padding: 8px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
</style>